import '@/style.css';
import LoginClass from "@/loginClass";
/*import { createApp } from "vue";
import AppVue from "@/vue/AppVue";
import { store } from "@/vue/store";
import Config from "@/classes/Config";
import DynamicFonts from "@/classes/DynamicFonts";
const dynamicFonts=new DynamicFonts();

//document.location.search: "?..."
//document.location.hash: "#..."
if ((document.location.hostname==='127.0.0.1')||(document.location.hostname==='localhost')){
    Config.isLocal=true;
}

window.appVue=createApp(AppVue);
window.appVue.use(store);
window.appVue.$store=store;
window.appVue.mount('#app');
//*/

window.loginClass=new LoginClass();


